import { HTMLAttributes, ReactNode } from 'react'
import './modal.css'

interface ModalProps extends HTMLAttributes<HTMLElement> {
  isOpened: boolean,
  children: ReactNode,
  classes?: string
}
const Modal = ({ isOpened = false,  children, classes, ...rest }: ModalProps) => {

  if (isOpened) {
    return (
      <div className='content'{...rest } >
        <div className={`modal ${classes}`} >
          {children}
        </div>
      </div>
    )
  }
  return (
    <></>
  )
}

export default Modal;